'use client';

import { useEffect, useState } from 'react';
import { useHeadsObserver } from '../../../hooks/useHeadObserver';
import './tableOfContent.css';

function TableOfContent() {
  const [headings, setHeadings] = useState([]);
  const { activeId } = useHeadsObserver();
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
    const elements = Array.from(document.querySelectorAll('.toc'))
      .filter((elem) => elem.nodeName === 'H2')
      .map((elem) => ({
        id: elem.id,
        text: elem.innerText,
        level: Number(elem.nodeName.charAt(1)),
      }));
    setHeadings(elements);
  }, []);

  // Render empty placeholder during SSR to prevent hydration mismatch
  if (!isMounted) {
    return (
      <div className="widget mt-4">
        <span className="bg-light d-block py-2 rounded shadow text-center h6 mb-0">
          Table of Content
        </span>
        <div className="mt-4">
          <nav className="table-of-content-nav">
            <ul>
              {headings.map((heading) => (
                <li key={heading.id}>
                  <a
                    href={`#${heading.id}`}
                    className={activeId === heading.id ? 'active-heading' : ''}
                  >
                    {heading.text}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    );
  }

  return (
    <div className="widget mt-4">
      <span className="bg-light d-block py-2 rounded shadow text-center h6 mb-0">
        Table of Content
      </span>

      <div className="mt-4">
        <nav className="table-of-content-nav">
          <ul>
            {headings.map((heading) => (
              <li key={heading.id}>
                <a
                  href={`#${heading.id}`}
                  onClick={(e) => {
                    e.preventDefault();
                    const element = document.querySelector(`#${heading.id}`);
                    if (element) {
                      window.scrollTo({
                        behavior: 'smooth',
                        top:
                          element.getBoundingClientRect().top
                          - document.body.getBoundingClientRect().top
                          - 80,
                      });
                    }
                  }}
                  className={activeId === heading.id ? 'active-heading' : ''}
                >
                  {heading.text}
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
}

export default TableOfContent;
